import React from "react";
import ChatModule from "../components/ChatModule";

export default function ChatPage() {
  return (
    <div className="h-[calc(100vh-3.5rem)] md:h-screen md:max-h-screen" data-testid="chat-page">
      <ChatModule embedded={false}/>
    </div>
  );
}
